import * as aTypes from "../actions/actionTypes";
import { updateObject, sortByAttributeID,sortByAttribute } from "../../helpers/index";
// import { filtersModel } from "../../models/filters";

const initialState = {
  activities: null,
  mapActivities: null,
  filteredActivities: null,
  activities_error: null,
};

/**
 * Routes [STEPS]
 * Step 05: This reducer (.../reducer/activities.js) will redirect the type to a reducers function;
 * > Go to: Step 06 - in this file.
 */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.ACTIVTS_SET:
      return setActivities(state, action);
    case aTypes.ACTIVTS_FILTRED_SET:
      return setFiltredActivities(state, action);
    case aTypes.ACTIVTS_FAIL:
      return fetchActivitiesFailed(state, action);
    default:
      return state;
  }
};

/**
 * Routes [STEPS]
 * Step 06: This reducers function will update the state;
 * > Go to: Done! You have completed it! :))
 */
const setActivities = (state, action) => {
  let mapActivities = null;
  if (action.activities)
    action.activities.forEach((act) => {
      mapActivities = { ...mapActivities, [act.id]: act };
    });
  return updateObject(state, {
    //activities: sortByAttributeID(action.activities, "id", false),
    activities: sortByAttribute(action.activities, "popularity", true),
    mapActivities: mapActivities,
  });
};

const setFiltredActivities = (state, action) => {
  return updateObject(state, {
    filteredActivities: action.filteredActivities,
  });
};

const fetchActivitiesFailed = (state, action) => {
  return updateObject(state, {
    activities_error: action.activities_error,
  });
};

export default reducer;
